import { TourPromotionViewModel } from '@api/v3';
import { Promotions } from '@components/cards/opportunity/OpportunityCard';

import { PriceDetailsDrawerItem } from '../components/PriceDetails/props';
import { SelectedVariations } from '../context/types';

export const formatPriceDetails = (
  variations: SelectedVariations[]
): Array<PriceDetailsDrawerItem> =>
  variations?.map((variation, index) => ({
    tabNumber: index,
    id: variation.id,
    title: variation.title || '',
    price: variation.price || 0,
    currency: variation.currency,
    guests: variation.guests,
    day: variation.day,
    nightCount: variation.nightCount,
    packageDetailId: variation.packageDetailId,
    variationId: variation.variationId,
    roomId: variation.roomId || '',
  })) || [];

export const formatTourPromotions = (
  tourPromotions?: TourPromotionViewModel[]
): Promotions[] =>
  tourPromotions?.map((item) => ({
    name: item.name || '',
    description: item.description || '',
    image: item.image || '/static/images/setur-static.jpg',
  })) || [];
export const formatDatesRange = (
  dates: number[] | string[] | string
): string => {
  if (typeof dates === 'string') {
    dates = [dates];
  }

  if (dates.length === 0) return '';

  const formatDate = (dateString: number | string): string => {
    const dateStr = String(dateString);
    const year = dateStr.slice(0, 4);
    const month = dateStr.slice(4, 6);
    return `${year}-${month}`;
  };

  const firstDate = formatDate(dates[0]);
  if (dates.length === 1) return firstDate;
  const lastDate = formatDate(dates[dates.length - 1]);

  return `${firstDate} - ${lastDate}`;
};
